import { forwardRef, type Ref, type SVGProps } from "react";
const IconRotateCounterClockwiseOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M15.56 3.65a.97.97 0 0 0 0-1.367.955.955 0 0 0-1.358 0l-2.611 2.63a.97.97 0 0 0-.28.717.97.97 0 0 0 .28.717l2.611 2.63a.955.955 0 0 0 1.357 0 .97.97 0 0 0 0-1.367l-1.034-1.04 5.874.018c3.464.01 6.269 2.835 6.28 6.323l.023 8.139a.963.963 0 0 0 .963.963.963.963 0 0 0 .957-.969l-.025-8.138c-.013-4.552-3.673-8.238-8.193-8.251l-5.825-.018.98-.986z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.378 13.74c0-.91.733-1.648 1.637-1.648h14.51c.903 0 1.636.738 1.636 1.648v14.612c0 .91-.733 1.648-1.637 1.648H5.014a1.64 1.64 0 0 1-1.636-1.648zm1.919 14.327V14.025h13.945v14.042z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRotateCounterClockwiseOutlineSVG);
ForwardRef.displayName = "IconRotateCounterClockwiseOutline";
export { ForwardRef as IconRotateCounterClockwiseOutline };
